import { render, staticRenderFns } from "./DialogManageWidgetComponent.vue?vue&type=template&id=51633610&"
import script from "./DialogManageWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./DialogManageWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogManageWidgetComponent.vue?vue&type=style&index=0&id=51633610&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports